import endpoints, { axios } from "../config/api";

async function getTotalUserNotifications() {
  const response = await axios.get(endpoints.account.totalNotifications());
  return response.data;
}

export default getTotalUserNotifications;
